import React, { Component } from "react";
import { Sidebarc } from "../src/Sidebar";
import { Appheaderc } from "./Appheader";
import { Button, Paper, Typography ,Modal,MenuItem,Divider,IconButton,Tooltip, TableCell,TableBody,TableRow,TableHead,TableContainer,TablePagination, Table,Avatar,Switch} from "@mui/material";
import { Box, Backdrop, CircularProgress } from "@mui/material";
import Grid from "@mui/material/Grid2";
import {
  TextField,
} from "@mui/material";
import base from "./baseurl";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import EditIcon from "@mui/icons-material/Edit";
import ReadMoreIcon from "@mui/icons-material/ReadMore";
import CloseIcon from "@mui/icons-material/Close";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";


const drawerWidth = 235;
class Settings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      privacy_policy: "",
      terms_and_condition: "",
      whatsapp_no: "",
      contact_no: "",
      linked_in: "",
      email_id : "",


      tab_value : "one",


      tab: "one",
      is_loader_open: false,
      is_loader_tt: false,

      /////////////////// category details //////////////

      category_name: "",
      category_img: "",
      category: [],
      category_count: 0,
      category_page: 0,
      category_rowPerPage: 10,
      is_edit_category: false,
      category_id: "",
      is_delete_category: false,
      category_select: [],


/////////////// banner details ////////////////

      banner_img : "",
      banner_type : "",
      banner_name : "",
      bannerList:[],
      banner_count: 0,
      banner_page: 0,
      banner_rowPerPage: 10,

sub_category_id:""

    };
    this.handleChange = this.handleChange.bind();
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  handleChangee = (e) => {
    this.setState({
      [e.target.name]: e.target.files[0],
    });
  };

    handleChangeee = (e) => {

    this.setState({
      [e.target.name]: e.target.files[0],
    });

  };

componentDidMount(){
  this.retriveCategory();
  this.retriveBaner();

  fetch(`${base.base_url}/retriveSettings`, {
    headers: {
      "content-type": "application/json",
    },
    method: "post",
    body: JSON.stringify({
      id : '670be1dbe9ed547f5543e721'
    }),
  })
    .then((res) => {
      return res.json();
    })
    .then(async (result) => {
      this.setState({
        privacy_policy: result.data.privacy_policy,
        terms_and_condition: result.data.terms_and_condition,
        whatsapp_no: result.data.whatsapp_no,
        contact_no: result.data.contact_no,
        linked_in: result.data.linked_in,
      })
    });

}



  sucessfull = (data) => {
    toast.info(
      <Typography sx={{ fontSize: 13, fontWeight: "bold" }}>
        {data}
      </Typography>,
      {
        position: "top-right",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        draggable: true,
        progress: undefined,
        icon: "🚀",
        theme: "colored",
      }
    );
  };


  updateData = () => {
    toast.info(
      <Typography sx={{ fontSize: 13, fontWeight: "bold" }}>
        Settings updated{" "}
      </Typography>,
      {
        position: "top-right",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        draggable: true,
        progress: undefined,
        icon: "🚀",
        theme: "colored",
      }
    );
  };

  
  error = () => {
    toast.error(
      <Typography sx={{ fontSize: 13, fontWeight: "bold" }}>
        Fill all fields
      </Typography>,
      {
        position: "top-right",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        draggable: true,
        progress: undefined,
        icon: "🚀",
        theme: "colored",
      }
    );
  };


  updatesettings = () => {
 
if(this.state.privacy_policy!== ""&&
  this.state.terms_and_condition!== ""&&
  this.state.whatsapp_no!== ""&&
  this.state.contact_no!== ""&&
  this.state.linked_in!== ""){

   fetch(`${base.base_url}/updateSettings`, {
      headers: {
        "content-type": "application/json",
      },
      method: "put",
      body: JSON.stringify({
        privacy_policy: this.state.privacy_policy,
        terms_and_condition: this.state.terms_and_condition,
        whatsapp_no: this.state.whatsapp_no,
        contact_no: this.state.contact_no,
        linked_in: this.state.linked_in,
        id : '670be1dbe9ed547f5543e721'
      }),
    })
      .then((res) => {
        return res.json();
      })
      .then(async (result) => {
        this.updateData();
      });

  }else{

this.fieldunfilled()

  }
 
  };


  
  saveCategory = () => {
    if (this.state.category_name !== "" && this.state.category_img !== "") {
      let formData = new FormData();
      formData.append("category_name", this.state.category_name);
      formData.append("category_img", this.state.category_img);

      this.setState({ is_loader_tt: true }, () => {
        fetch(`${base.base_url}/category/addCategory`, {
          method: "post",
          body: formData,
        })
          .then((res) => {
            return res.json();
          })
          .then(() => {
            this.setState({
              is_loader_tt: false,
              category_name: "",
            });
            this.sucessfull("Successfull");
            this.retriveCategory();
          });
      });
    } else {
      this.error("Fill All Fields");
    }
  };

  retriveCategorySelect = () => {
    fetch(`${base.base_url}/category/retriveCategoryListForselect`, {
      headers: {
        "content-type": "application/json",
      },
      method: "get",
    })
      .then((res) => {
        return res.json();
      })
      .then((result) => {
        this.setState({
          category_select: result.data,
        });
      });
  };

  retriveCategory = () => {
    fetch(
      `${base.base_url}/category/retriveCategoryList/:${this.state.category_page}/:${this.state.category_rowPerPage}`,
      {
        headers: {
          "content-type": "application/json",
        },
        method: "get",
      }
    )
      .then((res) => {
        return res.json();
      })
      .then((result) => {
        this.setState({
          category: result.data,
          category_count: result.size,
        });
      });
  };

  handleChangePage_Category = (event, newPage) => {
    this.setState({ category_page: newPage }, () => {
      this.retriveCategory();
    });
  };

  handleChangeRowsPerPage_Category = (event) => {
    this.setState(
      {
        category_rowPerPage: parseInt(event.target.value, 10),
        category_page: 0,
      },
      () => {
        this.retriveCategory();
      }
    );
  };


  ////////////////// banner section  ////////////////

  handleChangePage_banner = (event, newPage) => {
    this.setState({banner_page: newPage }, () => {
      this.retriveBaner();
    });
  };

  handleChangeRowsPerPage_banner = (event) => {
    this.setState(
      {
        banner_rowPerPage: parseInt(event.target.value, 10),
        banner_page: 0,
      },
      () => {
        this.retriveBaner();
      }
    );
  };

  saveBanner = () => {
    if (this.state.banner_name!== "" && this.state.banner_img !== "" & this.state.banner_type!=="") {
      let formData = new FormData();
      formData.append("banner_name", this.state.banner_name);
      formData.append("banner_img", this.state.banner_img);
       formData.append("banner_type", this.state.banner_type);

      this.setState({ is_loader_tt: true }, () => {
        fetch(`${base.base_url}/banner/addBanner`, {
          method: "post",
          body: formData,
        })
          .then((res) => {
            return res.json();
          })
          .then(() => {
            this.setState({
              is_loader_tt: false,
              banner_name: "",
              banner_img:"",
              banner_type:""
            });
            alert("Successfull");
            this.retriveBaner();
          });
      });
    } else {
      this.error("Fill All Fields");
    }
  };

  retriveBaner = () => {
    fetch(
      `${base.base_url}/banner/retriveBanerList/:${this.state.banner_page_page}/:${this.state.banner_rowPerPage}`,
      {
        headers: {
          "content-type": "application/json",
        },
        method: "get",
      }
    )
      .then((res) => {
        return res.json();
      })
      .then((result) => {
        this.setState({
          bannerList: result.data,
          banner_count: result.size,
        });
      });
  };





  render() {
    return (
      <div>
        <Box sx={{ display: "flex" }}>
          <Sidebarc />
          <Box
            sx={{ width: { sm: `calc(100% - ${drawerWidth}px)`, xs: "100%" } }}
          >
            <Box sx={{ pl: { xs: 1, sm: 3 },pt:{xs: 1, sm: 3 },pr:{xs: 1, sm: 3 }, mt: 6 }}>
        


   <Typography
                style={{
                  fontWeight: "bold",
                  color: "#1b7bce",
                  fontSize: 16,
                  marginTop: 15,
                  marginBottom: 5,
                  marginLeft: 10,
                }}
              >
               General Setting
              </Typography>




      <Box >
        <Box
         
        >
          <Box sx={{ height: "100%", width: "100%" }}>
            {
              /// header data
            }
            <Box
              sx={{
                height: 47,
                width: "100%",
                backgroundColor: "#fff",
                borderRadius: 0,
                mt: 0.2,
                borderBottom: 0.5,
                borderBottomColor: "#dddddd",
              }}
            >
              <Tabs
                value={this.state.tab}
                onChange={this.handleChange}
                aria-label="wrapped label tabs example"
              >
                <Tab
                  value="one"
                  sx={{
                    textTransform: "uppercase",
                    fontWeight: "500",
                    fontSize: 12,
                  }}
                  label="Category"
                  onClick={() => this.setState({ tab: "one" })}
                  wrapped
                />

                <Tab
                  value="two"
                  sx={{
                    textTransform: "uppercase",
                    fontWeight: "500",
                    fontSize: 12,
                  }}
                  label="Banner"
                  onClick={() => this.setState({ tab: "two" })}
                  wrapped
                />

              </Tabs>
            </Box>

            {
              //////body segment and division
            }

            <Box
              sx={{
                pl: { xs: 1, sm: 3 },
                pt: { xs: 1, sm: 2 },
                pr: { xs: 1, sm: 3 },
              }}
            >
              <Box sx={{ display: this.state.tab == "one" ? "block" : "none" }}>
                <Grid container spacing={2}>
                  <Grid item size={{ xs: 12, sm: 12, md: 8 }}>
                    <Box>
                      <Paper
                        variant="outlined"
                        elevation={1}
                        style={{ minHeight: 150, width: "100%", color: "#fff" }}
                      >
                        <Box sx={{ padding: 3 }}>
                          <Typography
                            style={{
                              fontWeight: "bold",
                              color: "#1b7bce",
                              fontSize: 15,
                              marginTop: 3,
                              textTransform: "uppercase",
                              marginBottom: 8,
                              marginLeft: 1,
                            }}
                          >
                            Category
                          </Typography>

                          <Box sx={{ mt: 0, padding: 0 }}>
                            <Paper
                              variant="outlined"
                              sx={{ minHeight: 250, width: "100%" }}
                            >
                              <TableContainer
                                component={Box}
                                sx={{ backgroundColor: "#f4f4f6" }}
                              >
                                <Table
                                  sx={{ minWidth: 620 }}
                                  size="small"
                                  aria-label="a dense table"
                                >
                                  <TableHead>
                                    <TableRow>
                                      <TableCell
                                        align="left"
                                        sx={{
                                          fontSize: 14,
                                          fontWeight: "600",
                                          color: "#008ffb",
                                        }}
                                      >
                                        Sr No
                                      </TableCell>

                                      <TableCell
                                        align="center"
                                        sx={{
                                          fontSize: 14,
                                          fontWeight: "600",
                                          color: "#008ffb",
                                        }}
                                      >
                                        category Img
                                      </TableCell>
                                      <TableCell
                                        align="center"
                                        sx={{
                                          fontSize: 14,
                                          fontWeight: "600",
                                          color: "#008ffb",
                                        }}
                                      >
                                        category Name
                                      </TableCell>

                                      <TableCell
                                        align="right"
                                        sx={{
                                          fontSize: 14,
                                          fontWeight: "600",
                                          color: "#008ffb",
                                        }}
                                      >
                                        Action
                                      </TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {this.state.category.map((row, index) => (
                                      <TableRow
                                        key={row._id}
                                        sx={{
                                          "&:last-child td, &:last-child th": {
                                            border: 0,
                                          },
                                          backgroundColor:
                                            index % 2 ? "#f9f9f9" : "#fff",
                                        }}
                                      >
                                        <TableCell
                                          component="th"
                                          scope="row"
                                          sx={{ color: "#42526e" }}
                                        >
                                          <Box
                                            sx={{
                                              height: 20,
                                              minWidth: 60,
                                              display: "flex",
                                              justifyContent: "left",
                                              alignItems: "center",
                                            }}
                                          >
                                            <Typography
                                              sx={{
                                                fontSize: 12,
                                                fontWeight: 600,
                                                paddingLeft: 1,
                                                paddingRight: 1,
                                              }}
                                            >
                                              {index + 1}
                                            </Typography>
                                          </Box>
                                        </TableCell>

                                        <TableCell
                                          align="right"
                                          sx={{
                                            color: "#42526e",
                                            fontSize: 12,
                                          }}
                                        >
                                          <Box
                                            sx={{
                                              display: "flex",
                                              width: "100%",
                                              justifyContent: "center",
                                              alignItems: "center",
                                            }}
                                          >
                                            <Avatar  
                                              alt="Remy Sharp"
                                              src={
                                                base.base_url +
                                                "/" +
                                                row.category_img
                                              }
                                              sx={{ width: 24, height: 24 }}
                                            />
                                          </Box>
                                        </TableCell>

                                        <TableCell
                                          align="center"
                                          sx={{
                                            color: "#42526e",
                                            fontSize: 12,
                                          }}
                                        >
                                          {row.category_name}
                                        </TableCell>

                                        <TableCell align="right">
                                          <Box
                                            sx={{
                                              display: "flex",
                                              flexDirection: "row",
                                              justifyContent: "right",
                                            }}
                                          >
                                            <Tooltip title="EDIT">
                                              <IconButton
                                                size="small"
                                                onClick={() =>
                                                  this.setState({
                                                    is_edit_category: true,
                                                    category_id: row._id,
                                                    category_name:
                                                      row.category_name,
                                                    category_img:
                                                      row.category_img,
                                                  })
                                                }
                                              >
                                                <EditIcon
                                                  sx={{
                                                    color: "#00cfe8",
                                                    height: 17,
                                                    width: 17,
                                                  }}
                                                />
                                              </IconButton>
                                            </Tooltip>

                                            <Tooltip title="DELETE">
                                              <IconButton
                                                size="small"
                                                onClick={() => {
                                                  this.setState({
                                                    is_delete_category: true,
                                                    category_id: row._id,
                                                  });
                                                }}
                                              >
                                                <DeleteOutlinedIcon
                                                  sx={{
                                                    color: "red",
                                                    height: 17,
                                                    width: 17,
                                                  }}
                                                />
                                              </IconButton>
                                            </Tooltip>
                                          </Box>
                                        </TableCell>
                                      </TableRow>
                                    ))}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                              <Divider />
                              <TablePagination
                                rowsPerPageOptions={[5, 10, 25]}
                                component="div"
                                count={this.state.category_count}
                                rowsPerPage={this.state.category_rowPerPage}
                                page={this.state.category_page}
                                onPageChange={this.handleChangePage_Category}
                                onRowsPerPageChange={
                                  this.handleChangeRowsPerPage_Category
                                }
                              />
                            </Paper>
                          </Box>
                        </Box>
                      </Paper>
                    </Box>
                  </Grid>

                  <Grid item size={{ xs: 12, sm: 12, md: 4 }}>
                    <Paper
                      variant="outlined"
                      sx={{ minHeight: 200, width: "100%" }}
                    >
                      <Typography
                        sx={{
                          fontSize: 15,
                          fontWeight: "600",
                          p: 2,
                          textTransform: "uppercase",
                          pl: 4,
                        }}
                      >
                        Add Category
                      </Typography>

                      <Box sx={{ pl: 4, pr: 4 }}>
                        <Grid container spacing={2}>
                          <Grid item size={{ xs: 12 }}>
                            <Typography
                              sx={{
                                fontSize: 12,
                                color: "#515151",
                                fontWeight: "bold",
                                p: 0.5,
                              }}
                            >
                              Category Name
                            </Typography>
                            <TextField
                              size="small"
                              type="text"
                              placeholder="Example : Moter Vehical"
                              fullWidth
                              InputProps={{
                                style: { fontSize: 11, fontWeight: "500" },
                              }}
                              name="category_name"
                              onChange={this.handleChange}
                            />
                          </Grid>
                          {
                            // category_img
                          }

                          <Grid item size={{ xs: 12 }}>
                            <Typography
                              sx={{
                                fontSize: 12,
                                color: "#515151",
                                fontWeight: "bold",
                                p: 0.5,
                              }}
                            >
                              Category Img
                            </Typography>

                            <Box
                              sx={{
                                height: 40,
                                width: "100%",
                                backgroundColor: "#eff0f0",
                                display: "flex",
                                alignItems: "center",
                                borderRadius: 1,
                              }}
                            >
                              <input
                                type="file"
                                name="category_img"
                                onChange={this.handleChangee}
                                style={{ marginLeft: 6 }}
                              />
                            </Box>
                          </Grid>
                        </Grid>
                        <Box
                          sx={{
                            mt: 2,
                            mb: 2,
                            display: "flex",
                            flexDirection: "row",
                          }}
                        >
                          <Button
                            size="small"
                            variant="contained"
                            sx={{ textTransform: "none", height: 30 }}
                            onClick={this.saveCategory}
                          >
                            Save Category
                          </Button>
                          <Button
                            size="small"
                            color="error"
                            variant="contained"
                            sx={{ textTransform: "none", height: 30, ml: 2 }}
                            onClick={() =>
                              this.setState({
                                category_name: "",
                                category_id: "",
                              })
                            }
                          >
                            Cancel
                          </Button>
                        </Box>
                      </Box>
                    </Paper>
                  </Grid>
                </Grid>
              </Box>

              <Box sx={{ display: this.state.tab == "two" ? "block" : "none" }}>
                <Grid container spacing={2}>
                  <Grid item size={{ xs: 12, sm: 12, md: 8 }}>
                    <Box>
                      <Paper
                        variant="outlined"
                        elevation={1}
                        style={{ minHeight: 150, width: "100%", color: "#fff" }}
                      >
                        <Box sx={{ padding: 3 }}>
                          <Typography
                            style={{
                              fontWeight: "bold",
                              color: "#1b7bce",
                              fontSize: 15,
                              marginTop: 3,
                              textTransform: "uppercase",
                              marginBottom: 8,
                              marginLeft: 1,
                            }}
                          >
                           Banner Details
                          </Typography>

                          <Box sx={{ mt: 0, padding: 0 }}>
                            <Paper
                              variant="outlined"
                              sx={{ minHeight: 250, width: "100%" }}
                            >
                              <TableContainer
                                component={Box}
                                sx={{ backgroundColor: "#f4f4f6" }}
                              >
                                <Table
                                  sx={{ minWidth: 620 }}
                                  size="small"
                                  aria-label="a dense table"
                                >
                                  <TableHead>
                                    <TableRow>
                                      <TableCell
                                        align="left"
                                        sx={{
                                          fontSize: 14,
                                          fontWeight: "600",
                                          color: "#008ffb",
                                        }}
                                      >
                                        Sr. No
                                      </TableCell>

                                      <TableCell
                                        align="center"
                                        sx={{
                                          fontSize: 14,
                                          fontWeight: "600",
                                          color: "#008ffb",
                                        }}
                                      >
                                        Banner Name
                                      </TableCell>

                                      <TableCell
                                        align="center"
                                        sx={{
                                          fontSize: 14,
                                          fontWeight: "600",
                                          color: "#008ffb",
                                        }}
                                      >
                                        Banner Type
                                      </TableCell>

                                           <TableCell
                                        align="center"
                                        sx={{
                                          fontSize: 14,
                                          fontWeight: "600",
                                          color: "#008ffb",
                                        }}
                                      >
                                        Banner Img
                                      </TableCell>

                                      <TableCell
                                        align="right"
                                        sx={{
                                          fontSize: 14,
                                          fontWeight: "600",
                                          color: "#008ffb",
                                        }}
                                      >
                                        Action
                                      </TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {this.state.bannerList.map(
                                      (row, index) => (
                                        <TableRow
                                          key={row._id}
                                          sx={{
                                            "&:last-child td, &:last-child th":
                                              {
                                                border: 0,
                                              },
                                            backgroundColor:
                                              index % 2 ? "#f9f9f9" : "#fff",
                                          }}
                                        >
                                          <TableCell
                                            component="th"
                                            scope="row"
                                            sx={{ color: "#42526e" }}
                                          >
                                            <Box
                                              sx={{
                                                height: 20,
                                                minWidth: 60,
                                                display: "flex",
                                                justifyContent: "left",
                                                alignItems: "center",
                                              }}
                                            >
                                              <Typography
                                                sx={{
                                                  fontSize: 12,
                                                  fontWeight: 600,
                                                  paddingLeft: 1,
                                                  paddingRight: 1,
                                                }}
                                              >
                                                {index + 1}
                                              </Typography>
                                            </Box>
                                          </TableCell>

                                          <TableCell
                                            align="center"
                                            sx={{
                                              color: "#42526e",
                                              fontSize: 12,
                                              minWidth: 100,
                                            }}
                                          >
                                            {row.banner_name}
                                          </TableCell>

                                          <TableCell
                                            align="center"
                                            sx={{
                                              color: "#42526e",
                                              fontSize: 12,
                                              minWidth: 100,
                                            }}
                                          >
                                            {row.banner_type}
                                          </TableCell>

                                               <TableCell
                                            align="center"
                                            sx={{
                                              color: "#42526e",
                                              fontSize: 12,
                                              minWidth: 100,
                                            }}
                                          >
                                            <Avatar
                                              alt="Remy Sharp"
                                              src={
                                                base.base_url +
                                                "/" +
                                                row.banner_img
                                              }
                                              sx={{ width: 24, height: 24 }}
                                            />
                                            
                                          </TableCell>

                                          <TableCell align="right">
                                            <Box
                                              sx={{
                                                display: "flex",
                                                flexDirection: "row",
                                                justifyContent: "right",
                                              }}
                                            >
                                              <Tooltip title="EDIT">
                                                <IconButton
                                                  size="small"
                                                  onClick={() => {
                                                    this.setState({
                                                      is_edit_sub_category: true,
                                                      sub_category_id: row._id,
                                                      banner_name:
                                                        row.banner_name,
                                                        banner_img:row.banner_img,
                                                        banner_type:row.banner_type
                                                    });
                                                  }}
                                                >
                                                  <EditIcon
                                                    sx={{
                                                      color: "#00cfe8",
                                                      height: 17,
                                                      width: 17,
                                                    }}
                                                  />
                                                </IconButton>
                                              </Tooltip>

                                              <Tooltip title="DELETE">
                                                <IconButton
                                                  size="small"
                                                  onClick={() =>
                                                    this.setState({
                                                      is_delete_sub_category: true,
                                                      sub_category_id: row._id,
                                                    })
                                                  }
                                                >
                                                  <DeleteOutlinedIcon
                                                    sx={{
                                                      color: "red",
                                                      height: 17,
                                                      width: 17,
                                                    }}
                                                  />
                                                </IconButton>
                                              </Tooltip>
                                            </Box>
                                          </TableCell>
                                        </TableRow>
                                      )
                                    )}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                              <Divider />
                              <TablePagination
                                rowsPerPageOptions={[5, 10, 25]}
                                component="div"
                                count={this.state.banner_count}
                                rowsPerPage={this.state.banner_rowPerPage}
                                page={this.state.banner_page}
                                onPageChange={
                                  this.handleChangePage_banner
                                }
                                onRowsPerPageChange={
                                  this.handleChangeRowsPerPage_banner
                                }
                              />
                            </Paper>
                          </Box>
                        </Box>
                      </Paper>
                    </Box>
                  </Grid>

                  <Grid item size={{ xs: 12, sm: 12, md: 4 }}>
                    <Paper
                      variant="outlined"
                      sx={{ minHeight: 100, width: "100%" }}
                    >
                      <Typography
                        sx={{
                          fontSize: 15,
                          fontWeight: "600",
                          p: 2,
                          textTransform: "uppercase",
                          pl: 4,
                        }}
                      >
                        Add Banner
                      </Typography>

                      <Box sx={{ pl: 4, pr: 4 }}>
                        <Grid container spacing={2}>

                          <Grid item size={{ xs: 12 }}>
                            <Typography
                              sx={{
                                fontSize: 12,
                                color: "#515151",
                                fontWeight: "bold",
                                p: 0.5,
                              }}
                            >
                              Banner Type
                            </Typography>
                            <TextField
                              size="small"
                              type="text"
                              placeholder="Banner type"
                              fullWidth
                              InputProps={{
                                style: { fontSize: 11, fontWeight: "500" },
                              }}
                              select
                              name="banner_type"
                              value={this.state.banner_type}
                              onChange={this.handleChange}
                            >
                              {["Mobile Banner","Desktop Banner"].map((option) => (
                                <MenuItem
                                  key={option._id}
                                  sx={{ fontSize: 11 }}
                                  value={option}
                                  onClick={() =>
                                    this.setState({
                                      banner_type: option,
                                    })
                                  }
                                >
                                  {option}
                                </MenuItem>
                              ))}
                            </TextField>
                          </Grid>

                          <Grid item size={{ xs: 12 }}>
                            <Typography
                              sx={{
                                fontSize: 12,
                                color: "#515151",
                                fontWeight: "bold",
                                p: 0.5,
                              }}
                            >
                              Banner name
                            </Typography>
                            <TextField
                              size="small"
                              type="text"
                              placeholder="Sub Category"
                              fullWidth
                              InputProps={{
                                style: { fontSize: 11, fontWeight: "500" },
                              }}
                              name="banner_name"
                              value={this.state.banner_name}
                              onChange={this.handleChange}
                            />
                          </Grid>

                          <Grid item size={{ xs: 12 }}>
                            <Typography
                              sx={{
                                fontSize: 12,
                                color: "#515151",
                                
                                fontWeight: "bold",
                                p: 0.5,
                              }}
                            >
                        {this.state.banner_type=='Mobile Banner'?'Banner Img (max size 300kb , image dimention(500 * 500))':"Banner Img (max size 600kb , image dimention(1940 * 810))"} 
                            </Typography>

                            <Box
                              sx={{
                                height: 40,
                                width: "100%",
                                backgroundColor: "#eff0f0",
                                display: "flex",
                                alignItems: "center",
                                borderRadius: 1,
                              }}
                            >
                              <input
                                type="file"
                                name='banner_img'
                                onChange={this.handleChangeee}
                                style={{ marginLeft: 6 }}
                              />
                            </Box>
                          </Grid>

                        </Grid>
                        <Box
                          sx={{
                            mt: 2,
                            mb: 2,
                            display: "flex",
                            flexDirection: "row",
                          }}
                        >
                          <Button
                            size="small"
                            variant="contained"
                            sx={{ textTransform: "none", height: 30 }}
                            onClick={this.saveBanner}
                          >
                           Save Banner
                          </Button>
                          <Button
                            size="small"
                            color="error"
                            variant="contained"
                            sx={{ textTransform: "none", height: 30, ml: 2 }}
                          >
                            Cancel
                          </Button>
                        </Box>
                      </Box>
                    </Paper>
                  </Grid>
                </Grid>
              </Box>

         




            </Box>
          </Box>
        </Box>

        <Backdrop
          sx={(theme) => ({
            color: "#fff",
            backgroundColor: "transparent",
            zIndex: theme.zIndex.drawer + 1,
          })}
          open={this.state.is_loader_open}
          onClick={this.handleClose}
        >
          <CircularProgress sx={{ color: "#008ffb" }} />
        </Backdrop>

        {
          //////// category edit details here
        }

        <Box>
          <Modal
            open={this.state.is_edit_category}
            onClose={this.handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                width: "100%",
              }}
            >
              <Paper
                sx={{
                  width: { xs: "90%", sm: "90%", md: "30%", lg: "30%" },
                  height: "50vh",
                  backgroundColor: "#fff",
                  borderRadius: 2,
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "right",
                  }}
                >
                  <Paper
                    onClick={() =>
                      this.setState({
                        is_edit_category: false,
                        category_id: "",
                        category_name: "",
                      })
                    }
                  >
                    <CloseIcon
                      sx={{ height: 20, width: 20, color: "#2486bb" }}
                    />
                  </Paper>
                </Box>

                <Typography
                  sx={{
                    fontSize: 18,
                    fontWeight: "600",

                    paddingLeft: { xs: 2, sm: 4 },
                    mb: 2,
                  }}
                >
                  Update Category Details:
                </Typography>
                <Divider />
                <Box
                  sx={{
                    overflowY: "scroll",
                    "&::-webkit-scrollbar": {
                      width: "5px",
                      borderRadius: 10,
                    },
                  }}
                >
                  <Box
                    sx={{
                      paddingLeft: { xs: 2, sm: 4 },
                      paddingRight: { xs: 2, sm: 4 },
                      height: "76vh",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: 12,
                        color: "#515151",
                        fontWeight: "bold",
                        p: 0.5,
                        mt: 2,
                      }}
                    >
                      Category Name
                    </Typography>
                    <TextField
                      size="small"
                      type="text"
                      placeholder="For example 2025-2026"
                      fullWidth
                      InputProps={{
                        style: { fontSize: 11, fontWeight: "500" },
                      }}
                      name="category_name"
                      value={this.state.category_name}
                      onChange={this.handleChange}
                    />

                    <Typography
                      sx={{
                        fontSize: 12,
                        color: "#515151",
                        fontWeight: "bold",
                        p: 0.5,
                      }}
                    >
                      Category Img
                    </Typography>

                    <Box
                      sx={{
                        height: 40,
                        width: "100%",
                        backgroundColor: "#eff0f0",
                        display: "flex",
                        alignItems: "center",
                        borderRadius: 1,
                      }}
                    >
                      <input
                        type="file"
                        name="category_img"
                        onChange={this.handleChangee}
                        style={{ marginLeft: 6 }}
                      />
                    </Box>

                    <br />

                    <Button
                      onClick={() => {
                        if (
                          this.state.category_name !== "" &&
                          this.state.category_img !== ""
                        ) {
                          let formData = new FormData();
                          formData.append(
                            "category_name",
                            this.state.category_name
                          );
                          formData.append(
                            "category_img",
                            this.state.category_img
                          );

                          formData.append("_id", this.state.category_id);

                          fetch(
                            `${base.base_url}/category/updateCategory`,
                            {
                              method: "put",
                              body: formData,
                            }
                          )
                            .then((res) => {
                              return res.json();
                            })
                            .then(() => {
                              this.sucessfull("category details updated");
                              this.retriveCategory();
                              this.setState({
                                category_name: "",
                                category_id: "",
                                category_img: "",
                                is_edit_category: false,
                              });
                            });
                        } else {
                          this.sucessfull("Fill all fields");
                        }
                      }}
                      variant="contained"
                      disableElevation
                      size="small"
                      sx={{
                        backgroundColor: "#2486bb",
                        mt: 3,
                        textTransform: "none",
                      }}
                    >
                      Edit Category
                    </Button>
                  </Box>
                </Box>
              </Paper>
            </Box>
          </Modal>
        </Box>

        <Box>
          <Modal
            open={this.state.is_delete_category}
            onClose={this.handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                width: "100%",
              }}
            >
              <Paper
                sx={{
                  width: { xs: "90%", sm: "90%", md: "25%", lg: "25%" },
                  height: "35vh",
                  backgroundColor: "#fff",
                  borderRadius: 2,
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "right",
                  }}
                >
                  <Box
                    sx={{
                      height: 40,
                      backgroundColor: "#f29494",
                      width: "100%",
                      borderTopLeftRadius: 5,
                      borderTopRightRadius: 5,
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: 15,
                        color: "#fff",
                        mt: 1,
                        ml: 1,
                        fontWeight: "500",
                      }}
                    >
                      Confirm Deletation
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      height: 50,
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      mt: 1,
                    }}
                  >
                    <WarningAmberOutlinedIcon
                      sx={{ height: 35, width: 35, color: "#f29494" }}
                    />
                  </Box>

                  <Typography textAlign="center" sx={{ fontSize: 13 }}>
                    Are you sure want to delete this item?.
                  </Typography>
                  <Typography textAlign="center" sx={{ fontSize: 13 }}>
                    This action cannot be undone.
                  </Typography>

                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      width: "100%",
                      mt: 3,
                      justifyContent: "right",
                    }}
                  >
                    <Button
                      small="small"
                      variant="outlined"
                      onClick={() =>
                        this.setState({ is_delete_category: false })
                      }
                      sx={{ fontSize: 10 }}
                    >
                      Cancel
                    </Button>
                    <Button
                      size="small"
                      color="error"
                      variant="contained"
                      sx={{ fontSize: 10, ml: 1, mr: 3 }}
                      onClick={() => {
                        fetch(
                          `${base.base_url}/category/deleteCategory`,
                          {
                            headers: {
                              "content-type": "application/json",
                            },

                            method: "delete",
                            body: JSON.stringify({
                              _id: this.state.category_id,
                            }),
                          }
                        )
                          .then((res) => {
                            return res.json();
                          })
                          .then(() => {
                            this.setState({
                              category_id: "",
                              is_delete_category: false,
                            });
                            this.retriveCategory();
                            this.sucessfull("Deleted sucessfull");
                          });
                      }}
                    >
                      Delete
                    </Button>
                  </Box>
                </Box>
              </Paper>
            </Box>
          </Modal>
        </Box>

        {
          //////// sub category edit details here
        }

        <Box>
          <Modal
            open={this.state.is_edit_sub_category}
            onClose={this.handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                width: "100%",
              }}
            >
              <Paper
                sx={{
                  width: { xs: "90%", sm: "90%", md: "30%", lg: "30%" },
                  height: "50vh",
                  backgroundColor: "#fff",
                  borderRadius: 2,
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "right",
                  }}
                >
                  <Paper
                    onClick={() =>
                      this.setState({
                        is_edit_sub_category: false,
                        category_id: "",
                        category_name: "",
                        sub_category_name: "",
                      })
                    }
                  >
                    <CloseIcon
                      sx={{ height: 20, width: 20, color: "#2486bb" }}
                    />
                  </Paper>
                </Box>

                <Typography
                  sx={{
                    fontSize: 18,
                    fontWeight: "600",

                    paddingLeft: { xs: 2, sm: 4 },
                    mb: 2,
                  }}
                >
                  Update Banner Details:
                </Typography>
                <Divider />
                <Box
                  sx={{
                    overflowY: "scroll",
                    "&::-webkit-scrollbar": {
                      width: "5px",
                      borderRadius: 10,
                    },
                  }}
                >
                  <Box
                    sx={{
                      paddingLeft: { xs: 2, sm: 4 },
                      paddingRight: { xs: 2, sm: 4 },
                      height: "76vh",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: 12,
                        color: "#515151",
                        fontWeight: "bold",
                        p: 0.5,
                        mt: 2,
                      }}
                    >
                      Banner Name
                    </Typography>
                    <TextField
                      size="small"
                      type="text"
                      placeholder="For example 2025-2026"
                      fullWidth
                      InputProps={{
                        style: { fontSize: 11, fontWeight: "500" },
                      }}
                      name="banner_name"
                      value={this.state.banner_name}
                      onChange={this.handleChange}
                    />

                    <Typography
                      sx={{
                        fontSize: 12,
                        color: "#515151",
                        fontWeight: "bold",
                        p: 0.5,
                        mt: 2,
                      }}
                    >  
                      Category Name
                    </Typography>
                    <TextField
                      size="small"
                      type="text"
                      placeholder="Category"
                      fullWidth
                      InputProps={{
                        style: { fontSize: 11, fontWeight: "500" },
                      }}
                      select
                      name="banner_type"
                      value={this.state.banner_type}
                      onChange={this.handleChange}
                    >
                      {["Mobile Banner","Desktop Banner"].map((option) => (
                        <MenuItem
                          key={option}
                          sx={{ fontSize: 11 }}
                          value={option}
                          onClick={() =>
                            this.setState({
                              category_name: option,
                              category_id: option,
                            })
                          }
                        >
                          {option}
                        </MenuItem>
                      ))}
                    </TextField>
                    <br />


                         <Typography
                      sx={{
                        fontSize: 12,
                        color: "#515151",
                        fontWeight: "bold",
                        p: 0.5,
                      }}
                    >
                    Banner Image
                    </Typography>

                    <Box
                      sx={{
                        height: 40,
                        width: "100%",
                        backgroundColor: "#eff0f0",
                        display: "flex",
                        alignItems: "center",
                        borderRadius: 1,
                      }}
                    >
                      <input
                        type="file"
                        name="banner_img"
                        onChange={this.handleChangee}
                        style={{ marginLeft: 6 }}
                      />
                    </Box>



                    <Button
                      onClick={() => {
                        if (
                          this.state.banner_name !== "" &&
                          this.state.banner_type !== "" &&
                          this.state.banner_img !== "" 
                        ) {

                          let formData = new FormData()
                          formData.append('banner_name',this.state.banner_name);
                            formData.append('banner_type',this.state.banner_type);
                              formData.append('_id',this.state.sub_category_id);
                               formData.append('banner_img',this.state.banner_img);

                          fetch(
                            `${base.base_url}/banner/updateBanner`,
                            {
                              
                              method: "put",
                              body: formData
                            }
                          )
                            .then((res) => {
                              return res.json();
                            })
                            .then(() => {
                              this.sucessfull(" details updated");
                              this.retriveBaner();
                              this.setState({
                                is_edit_sub_category: false,
                                category_id: "",
                                banner_name: "",
                                banner_type: "",
                              });
                            });
                        } else {
                          this.error("Fill all fields");
                        }
                      }}
                      variant="contained"
                      disableElevation
                      size="small"
                      sx={{
                        backgroundColor: "#2486bb",
                        mt: 3,
                        textTransform: "none",
                      }}
                    >
                      Edit Bnaner
                    </Button>
                  </Box>
                </Box>
              </Paper>
            </Box>
          </Modal>
        </Box>

        <Box>
          <Modal
            open={this.state.is_delete_sub_category}
            onClose={this.handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                width: "100%",
              }}
            >
              <Paper
                sx={{
                  width: { xs: "90%", sm: "90%", md: "25%", lg: "25%" },
                  height: "35vh",
                  backgroundColor: "#fff",
                  borderRadius: 2,
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "right",
                  }}
                >
                  <Box
                    sx={{
                      height: 40,
                      backgroundColor: "#f29494",
                      width: "100%",
                      borderTopLeftRadius: 5,
                      borderTopRightRadius: 5,
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: 15,
                        color: "#fff",
                        mt: 1,
                        ml: 1,
                        fontWeight: "500",
                      }}
                    >
                      Confirm Deletation
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      height: 50,
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      mt: 1,
                    }}
                  >
                    <WarningAmberOutlinedIcon
                      sx={{ height: 35, width: 35, color: "#f29494" }}
                    />
                  </Box>

                  <Typography textAlign="center" sx={{ fontSize: 13 }}>
                    Are you sure want to delete this item?.
                  </Typography>
                  <Typography textAlign="center" sx={{ fontSize: 13 }}>
                    This action cannot be undone.
                  </Typography>

                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      width: "100%",
                      mt: 3,
                      justifyContent: "right",
                    }}
                  >
                    <Button
                      small="small"
                      variant="outlined"
                      onClick={() =>
                        this.setState({ is_delete_sub_category: false })
                      }
                      sx={{ fontSize: 10 }}
                    >
                      Cancel
                    </Button>
                    <Button
                      size="small"
                      color="error"
                      variant="contained"
                      sx={{ fontSize: 10, ml: 1, mr: 3 }}
                      onClick={() => {
                        fetch(
                          `${base.base_url}/banner/deleteBanner`,
                          {
                            headers: {
                              "content-type": "application/json",
                            },
                            method: "delete",
                            body: JSON.stringify({
                              _id: this.state.sub_category_id,
                            }),
                          }
                        )
                          .then((res) => {
                            return res.json();
                          })
                          .then(() => {
                            this.setState({
                              sub_category_id: "",
                              is_delete_sub_category: false,
                            });
                            this.retriveBaner();
                            this.sucessfull("Deleted sucessfull");
                          });
                      }}
                    >
                      Delete
                    </Button>
                  </Box>
                </Box>
              </Paper>
            </Box>
          </Modal>
        </Box>

  

        <Backdrop
          sx={(theme) => ({
            color: "#fff",
            backgroundColor: "transparent",
            zIndex: theme.zIndex.drawer + 1,
          })}
          open={this.state.is_loader_tt}
          onClick={this.handleClose}
        >
          <CircularProgress sx={{ color: "#008ffb" }} />
        </Backdrop>

        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
          //transition={Bounce}
        />
      </Box>

















            </Box>
          </Box>



       













          <Box
            sx={{
              display: "flex",
              position: "fixed",
              top: 0,
              left: { xs: 0, sm: 235 },
            }}
          >
            <Appheaderc />
          </Box>

        </Box>


        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </div>
    );
  }
}

export default Settings;
